export default "__VITE_ASSET__04hpq7Pg__"